export const BACKEND_URL =
  typeof window !== "undefined"
    ? import.meta.env.PROD
      ? `//${window.location.hostname}/api`
      : `//${window.location.hostname}:8000`
    : "";

export const FUNCTION_TYPES = ["ADMIN", "VOTER", "SUBSTITUTE", "FOR_INFO"] as const;

export const PHASE_TYPES = ["comment_phase", "review_phase", "vote_phase"] as const;

export const STRIPPED_PHASE_TYPES = ["comment", "review", "vote"] as const;

export const VOTE_CHOICES = ["yes", "no", "abstain"] as const;

export const DELEGATION_SCOPES = ["body", "voting_session"] as const;

export const VOTING_RULES: Record<number, { name: string; description: string }> = {
  1: {
    name: "Unanimity Vote",
    description: "All members must agree for a decision to pass.",
  },
  2: {
    name: "Qualified Majority Voting (QMV)",
    description:
      "Decision passes if supported by at least 55% of members representing at least 65% of the population.",
  },
};

export const OUTCOMES = ["adopted", "rejected"] as const;

export const OUTCOME_REASONS = [
  "quorum",
  "weighted_majority",
  "simple_majority",
  "blocking_minority",
  "partial_weighted_majority",
  "no_majority",
  "invalid_procedure",
] as const;

export const BODY_COLORS = [
  ["#212121", "#616161", "#9E9E9E", "#E0E0E0", "#F5F5F5"],
  ["#3E2723", "#5D4037", "#795548", "#A1887F", "#D7CCC8"],
  ["#B71C1C", "#D32F2F", "#F44336", "#E57373", "#FFCDD2"],
  ["#E65100", "#F57C00", "#FF9800", "#FFB74D", "#FFE0B2"],
  ["#F57F17", "#FBC02D", "#FFEB3B", "#FFF176", "#FFF9C4"],
  ["#1B5E20", "#388E3C", "#4CAF50", "#81C784", "#C8E6C9"],
  ["#004D40", "#00796B", "#009688", "#4DB6AC", "#B2DFDB"],
  ["#0D47A1", "#1976D2", "#2196F3", "#64B5F6", "#BBDEFB"],
  ["#4A148C", "#7B1FA2", "#9C27B0", "#BA68C8", "#E1BEE7"],
  ["#880E4F", "#C2185B", "#E91E63", "#F06292", "#F8BBD0"],
] as const;

export const BODY_COLORS_TAILWIND_SAFELIST = [
  ["bg-[#212121]", "bg-[#616161]", "bg-[#9E9E9E]", "bg-[#E0E0E0]", "bg-[#F5F5F5]"],
  ["bg-[#3E2723]", "bg-[#5D4037]", "bg-[#795548]", "bg-[#A1887F]", "bg-[#D7CCC8]"],
  ["bg-[#B71C1C]", "bg-[#D32F2F]", "bg-[#F44336]", "bg-[#E57373]", "bg-[#FFCDD2]"],
  ["bg-[#E65100]", "bg-[#F57C00]", "bg-[#FF9800]", "bg-[#FFB74D]", "bg-[#FFE0B2]"],
  ["bg-[#F57F17]", "bg-[#FBC02D]", "bg-[#FFEB3B]", "bg-[#FFF176]", "bg-[#FFF9C4]"],
  ["bg-[#1B5E20]", "bg-[#388E3C]", "bg-[#4CAF50]", "bg-[#81C784]", "bg-[#C8E6C9]"],
  ["bg-[#004D40]", "bg-[#00796B]", "bg-[#009688]", "bg-[#4DB6AC]", "bg-[#B2DFDB]"],
  ["bg-[#0D47A1]", "bg-[#1976D2]", "bg-[#2196F3]", "bg-[#64B5F6]", "bg-[#BBDEFB]"],
  ["bg-[#4A148C]", "bg-[#7B1FA2]", "bg-[#9C27B0]", "bg-[#BA68C8]", "bg-[#E1BEE7]"],
  ["bg-[#880E4F]", "bg-[#C2185B]", "bg-[#E91E63]", "bg-[#F06292]", "bg-[#F8BBD0]"],
] as const;
